module.exports = __webpack_public_path__ + "img/paypal.db4f721d.png";